﻿import React, { useEffect, useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Navbar } from './components/Navbar/Navbar.jsx';
import { Footer } from './components/Footer/Footer.jsx';
import { ProgressBar } from './components/ProgressBar/ProgressBar.jsx';
import { BackToTop } from './components/BackToTop/BackToTop.jsx';
import { Assistant } from './components/Assistant/Assistant.jsx';
import { PageCurtain } from './components/PageCurtain/PageCurtain.jsx';
import { useLenis, getLenis } from './hooks/useLenis.js';
import { useSpotlight } from './hooks/useSpotlight.js';

import { Home } from './pages/Home/Home.jsx';
import { Introduction } from './pages/Introduction/Introduction.jsx';
import { BusinessModel } from './pages/BusinessModel/BusinessModel.jsx';
import { Faq } from './pages/Faq/Faq.jsx';
import { Services } from './pages/Services/Services.jsx';
import { Approach } from './pages/Approach/Approach.jsx';
import { Careers } from './pages/Careers/Careers.jsx';
import { Contact } from './pages/Contact/Contact.jsx';
import './App.css';

const ScrollToTopOnNavigate = () => {
  const location = useLocation();

  useEffect(() => {
    const lenis = getLenis();
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
    const timer = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 50);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
};

export const App = () => {
  const containerRef = useRef(null);
  useLenis();
  useSpotlight(containerRef);

  return (
    <div ref={containerRef}>
      <a className="skip" href="#main">
        Skip to content
      </a>
      <ProgressBar />
      <Navbar />
      <ScrollToTopOnNavigate />
      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/index.html" element={<Home />} />

          <Route path="/introduction" element={<Introduction />} />
          <Route path="/pages/introduction.html" element={<Introduction />} />

          <Route path="/business-model" element={<BusinessModel />} />
          <Route path="/pages/business-model.html" element={<BusinessModel />} />

          <Route path="/faq" element={<Faq />} />
          <Route path="/pages/faq.html" element={<Faq />} />

          <Route path="/services" element={<Services />} />
          <Route path="/pages/services.html" element={<Services />} />

          <Route path="/approach" element={<Approach />} />
          <Route path="/pages/approach.html" element={<Approach />} />

          <Route path="/careers" element={<Careers />} />
          <Route path="/pages/careers.html" element={<Careers />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="/pages/contact.html" element={<Contact />} />

          {/* Catch-all fallback */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <BackToTop />
      <Assistant />
      <PageCurtain />
    </div>
  );
};